export default __webpack_public_path__ + "static/media/kebab.jpg.a54692f4.webp";